import React from 'react';

interface LoadingButtonProps {
  onClick: () => void | Promise<void>;
  loading: boolean;
  disabled?: boolean;
  children: React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  type?: 'button' | 'submit' | 'reset';
  title?: string;
  'aria-label'?: string;
}

export default function LoadingButton({ 
  onClick, 
  loading, 
  disabled = false, 
  children, 
  className = '', 
  style = {},
  type = 'button',
  title,
  'aria-label': ariaLabel
}: LoadingButtonProps) {
  const handleClick = async () => {
    if (!loading && !disabled) {
      await onClick();
    }
  };

  return (
    <>
      <style>
        {`
          @keyframes spin {
            0% { transform: translate(-50%, -50%) rotate(0deg); }
            100% { transform: translate(-50%, -50%) rotate(360deg); }
          }
          .loading-spinner {
            position: absolute;
            left: 50%;
            top: 50%;
            transform: translate(-50%, -50%);
            width: 16px;
            height: 16px;
            border: 2px solid transparent;
            border-top: 2px solid currentColor;
            border-radius: 50%;
            animation: spin 1s linear infinite;
          }
        `}
      </style>
      <button
        type={type}
        onClick={handleClick}
        disabled={disabled || loading}
        title={title}
        aria-label={ariaLabel}
        className={`loading-button ${className} ${loading ? 'loading' : ''}`}
        style={{
          position: 'relative',
          cursor: loading || disabled ? 'not-allowed' : 'pointer',
          opacity: loading || disabled ? 0.7 : 1,
          ...style
        }}
      >
        {loading && <div className="loading-spinner" />}
        <span style={{ opacity: loading ? 0 : 1 }}>
          {children}
        </span>
      </button>
    </>
  );
}
